"use client"

import {
    createContext,
    useContext,
    type Dispatch,
    type MouseEvent,
    type RefObject,
    type SetStateAction
} from "react"
import {
    type MenuItemTypes,
    type NavigationGlobalLink
} from "@/src/utils/navigation/menuItems"

export type DesktopNavContextValue = {
    active: string | null
    setActive: Dispatch<SetStateAction<string | null>>
    activeItem: MenuItemTypes | null
    allMenuItems: MenuItemTypes[]
    globalLinks: NavigationGlobalLink[]
    itemsByKey: Map<string, MenuItemTypes>
    panelRef: RefObject<HTMLDivElement | null>
    clearClose: () => void
    scheduleClose: () => void
    clearOpen: () => void
    scheduleOpen: (key: string) => void
    isSafeTarget: (to: EventTarget | null) => boolean
    handleDropdownLeave: (e: MouseEvent) => void
    /** True when the active dropdown was opened with the keyboard, so the panel moves focus into itself. */
    openedViaKeyboard: boolean
    /** Opens a dropdown from the keyboard and signals the panel to focus its first item. */
    openFromKeyboard: (key: string) => void
    /** Returns focus to the L1 trigger of the currently active item (used on Escape / Tab-out). */
    focusActiveTrigger: () => void
}

const DesktopNavContext = createContext<DesktopNavContextValue | null>(null)

export function useDesktopNavContext(): DesktopNavContextValue {
    const ctx = useContext(DesktopNavContext)
    if (!ctx)
        throw new Error("useDesktopNavContext must be used within DesktopNavProvider")
    return ctx
}

export default DesktopNavContext
